import { z } from "zod";

export const registerSchema = z.object({
  firstName: z
    .string()
    .min(2, "Ad en az 2 karakter olmalıdır")
    .max(50, "Ad en fazla 50 karakter olabilir")
    .regex(
      /^[a-zA-ZçğıöşüÇĞIİÖŞÜ\s]+$/,
      "Ad sadece harf içerebilir",
    ),
  lastName: z
    .string()
    .min(2, "Soyad en az 2 karakter olmalıdır")
    .max(50, "Soyad en fazla 50 karakter olabilir")
    .regex(
      /^[a-zA-ZçğıöşüÇĞIİÖŞÜ\s]+$/,
      "Soyad sadece harf içerebilir",
    ),
  email: z
    .string()
    .min(1, "E-posta adresi gereklidir")
    .email("Geçerli bir e-posta adresi giriniz"),
  phone: z.string().min(1, "Telefon numarası gereklidir"),
  gender: z.enum(["male", "female", "unknown"], {
    message: "Cinsiyet seçimi gereklidir",
  }),
  countryId: z.number(),
  // Dynamic agreement fields will be added at runtime
});

export const verificationCodeSchema = z.object({
  code: z
    .string()
    .min(5, "Kod 5 haneli olmalıdır")
    .max(5, "Kod 5 haneli olmalıdır")
    .regex(/^\d+$/, "Kod sadece rakam içermelidir"),
});

export type RegisterFormData = z.infer<typeof registerSchema> & {
  [key: `agreement_${number}`]: boolean;
};

export type VerificationCodeData = z.infer<typeof verificationCodeSchema>;